var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.83325H5.33999M1.33333 2.96659V5.94959C1.33333 6.27572 1.33333 6.43879 1.37017 6.59225C1.40283 6.72825 1.4567 6.85832 1.52981 6.97765C1.61226 7.11219 1.72756 7.22752 1.95817 7.45812L7.07059 12.5705C7.86259 13.3625 8.25866 13.7586 8.71526 13.9069C9.11699 14.0375 9.54966 14.0375 9.95133 13.9069C10.408 13.7586 10.8041 13.3625 11.5961 12.5705L13.0706 11.096C13.8626 10.304 14.2587 9.90792 14.407 9.45125C14.5375 9.04958 14.5375 8.61692 14.407 8.21518C14.2587 7.75858 13.8626 7.36252 13.0706 6.57052L7.95819 1.45809C7.72759 1.22749 7.61226 1.11219 7.47773 1.02973C7.35839 0.956625 7.22833 0.902752 7.09233 0.870092C6.93886 0.833252 6.77579 0.833252 6.44967 0.833252H3.46666C2.71993 0.833252 2.34655 0.833252 2.06134 0.978579C1.81046 1.10641 1.60648 1.31038 1.47865 1.56127C1.33333 1.84648 1.33333 2.21985 1.33333 2.96659ZM5.66666 4.83325C5.66666 5.01735 5.51742 5.16659 5.33333 5.16659C5.14923 5.16659 4.99999 5.01735 4.99999 4.83325C4.99999 4.64916 5.14923 4.49992 5.33333 4.49992C5.51742 4.49992 5.66666 4.64916 5.66666 4.83325Z",
    stroke: "#107332",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e6a46980cb740330334fc59458cd3d87.svg";
export { ForwardRef as ReactComponent };